import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaMessageList from './VaMessageList.vue'

export const VaMessageList = withConfigTransport(_VaMessageList)
